import axios from '../axios'

export default class TagsService {

  getTagsOfType(type) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/tags/' + type
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteTag(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/tag/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateTag(tag) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/tag/' + tag.id 
        
        var response = await axios.put(path, tag)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  saveTag(tag) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/tag'
        
        var response = await axios.post(path, tag)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllTags() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/tags'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}